import React, { useState } from "react";
import { Button, ButtonGroup } from "@chakra-ui/react";

interface ToggleOption {
  label: string;
  value: string;
}

interface ToggleButtonGroupProps {
  options: ToggleOption[];
  defaultSelected: string;
  onChange?: (value: string) => void;
}

const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  options,
  defaultSelected,
  onChange,
}) => {
  const [selected, setSelected] = useState(defaultSelected || options[0].value);

  const handleClick = (val: string) => {
    setSelected(val);
    onChange?.(val);
  };

  return (
    <ButtonGroup
      isAttached
      borderRadius="100px"
      background="#CDD6DC3D"
      boxShadow="0px 4px 8px 0px rgba(0, 0, 0, 0.1), 0px 0px 4px 0px rgba(0, 0, 0, 0.05)"
      border="1px solid #E6E6E6"
      display="flex"
      whiteSpace="nowrap"
      gap={4}
      p={0}
    >
      {options?.map((opt) => (
        <Button
          key={opt.value}
          onClick={() => handleClick(opt.value)}
          borderRadius="100px"
          fontWeight="600"
          fontSize="16px"
          color={selected === opt.value ? "#0FABBE" : "#798692"}
          bg={selected === opt.value ? "white" : "transparent"}
          border={selected === opt.value ? "0.5px solid #A7B2BA" : "none"}
          boxShadow={selected === opt.value ? "0px 1px 4px 0px #0000001F" : "none"}
          _hover={{
            bg: selected === opt.value ? "white" : "transparent",
          }}
          _focus={{ boxShadow: "none" }}
          py={2}
          px={4}
          minW="130px"
        >
          {opt.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default ToggleButtonGroup;
